function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from 'react';

function SearchCircleOutlineIconHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#594F51",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.036 14.965a5 5 0 10-7.072 7.07 5 5 0 007.072-7.07zm1.474 6.838c.709.704 2.005 1.967 3.888 3.788a.5.5 0 11-.695.718 502.324 502.324 0 01-3.816-3.716l-.144.15a6 6 0 11.767-.94z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}

export default SearchCircleOutlineIconHover;